
import Tag2 from "../../../assets/filled/Tag2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Tag2Icon({ className, dataTestid = "Tag2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Tag2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
